export type DiscountUnit = '%' | 'R$';

export function parseDiscount(value: unknown): number {
  if (value === null || value === undefined || value === '') return 0;
  return Number(String(value).trim().replace(',', '.'));
}

export function roundDiscount(value: number): number {
  return Number(value.toFixed(7));
}

export function discountToPercentage(
  value: number,
  unit: DiscountUnit,
  price: number,
): number {
  if (unit === '%') return value;
  return Number.isFinite(price) && price > 0 ? (value * 100) / price : 0;
}

export function percentageToDiscount(
  value: number,
  unit: DiscountUnit,
  price: number,
): number {
  return unit === '%' ? value : (price * value) / 100;
}

export function signedDiscount(value: number, signal: string): number {
  return signal === '+' ? -Math.abs(value) : Math.abs(value);
}
